import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-array',
  templateUrl: './formly-array.component.html',
  styleUrl: './formly-array.component.scss',
  imports: [FormlyModule],
})
export class FormlyArrayComponent extends FieldArrayType {}
